import {
  IExternalLogger,
  LogInputType,
  LogLevel,
  LOG_LEVEL_NAMES,
  LogParametersType,
} from 'src/logging/types';
import { DefaultLogger } from 'src/logging/defaultLogger';

const replacer = (key: string, value: unknown) => {
  if (key === 'credentials') {
    return {
      clientId: `****`,
      clientSecret: `****`,
    };
  }

  if (value instanceof Map) {
    return Array.from(value.entries());
  }

  return value;
};

function template(strings: TemplateStringsArray, keys?: unknown[]): string {
  let res = '';

  if (keys) {
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (typeof key === 'object') {
        try {
          res += strings[i] + JSON.stringify(key, replacer);
        } catch (error) {
          res += strings[i] + "{object}";
        }
      } else if (typeof key === 'string') {
        res += strings[i] + "'" + key + "'";
      } else {
        res += strings[i] + key;
      }
    }
  }

  res += strings[strings.length - 1];
  return res;
}

export class KameleoonLogger {
  private static logger: IExternalLogger = new DefaultLogger();
  private static logLevel: LogLevel = LogLevel.WARNING;

  public static setLogger(logger: IExternalLogger): void {
    KameleoonLogger.logger = logger;
  }

  public static setLogLevel(logLevel: LogLevel): void {
    KameleoonLogger.logLevel = logLevel;
  }

  public static log({ level, strings, keys }: LogParametersType): void {
    if (!KameleoonLogger.checkLevel(level)) return;

    let message: string;

    if (typeof strings === 'string') {
      message = strings;
    } else if (typeof strings === 'function') {
      try {
        message = strings();
      } catch (error) {
        message = 'Failed to log message';
      }
    } else {
      message = template(strings, keys);
    }

    KameleoonLogger.writeMessage(level, message);
  }

  public static info(strings: LogInputType, ...keys: unknown[]): void {
    KameleoonLogger.log({ level: LogLevel.INFO, strings, keys });
  }

  public static error(strings: LogInputType, ...keys: unknown[]): void {
    KameleoonLogger.log({ level: LogLevel.ERROR, strings, keys });
  }

  public static warning(strings: LogInputType, ...keys: unknown[]): void {
    KameleoonLogger.log({ level: LogLevel.WARNING, strings, keys });
  }

  public static debug(strings: LogInputType, ...keys: unknown[]): void {
    KameleoonLogger.log({ level: LogLevel.DEBUG, strings, keys });
  }

  public static checkLevel(level: LogLevel): boolean {
    return level <= KameleoonLogger.logLevel && level !== LogLevel.NONE;
  }

  private static writeMessage(level: LogLevel, message: string): void {
    KameleoonLogger.logger.log(
      level,
      `Kameleoon [${LOG_LEVEL_NAMES[level]}]: ${message}`,
    );
  }
}
